import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Icons = {
  logo: function () {
    return (
      <img
        alt=""
        src="./"
        width="30"
        height="30"
        className="d-inline-block align-top"
      />
    );
  },
  SuccessRegisterIcon: function () {
    return (
      <svg
        width="69"
        height="45"
        viewBox="0 0 69 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="31.5" cy="22.5" r="22.5" fill="#052c65" />
        <path
          d="M18.75 24.75L27.375 33L44.25 14.625"
          stroke="white"
          strokeWidth="3"
        />
        <path
          d="M57 4L57.6735 5.72746H59.8532L58.0898 6.79508L58.7634 8.52254L57 7.45492L55.2366 8.52254L55.9102 6.79508L54.1468 5.72746H56.3265L57 4Z"
          fill="#052c65"
        />
        <path
          d="M65 14L65.449 15.0365H66.9021L65.7265 15.6771L66.1756 16.7135L65 16.0729L63.8244 16.7135L64.2735 15.6771L63.0979 15.0365H64.551L65 14Z"
          fill="#052c65"
        />
        <path
          d="M3 3L3.67354 5.07295H5.85317L4.08981 6.3541L4.76336 8.42705L3 7.1459L1.23664 8.42705L1.91019 6.3541L0.146831 5.07295H2.32646L3 3Z"
          fill="#052c65"
        />
        <path
          d="M67 38L67.449 39.0365H68.9021L67.7265 39.6771L68.1756 40.7135L67 40.0729L65.8244 40.7135L66.2735 39.6771L65.0979 39.0365H66.551L67 38Z"
          fill="#052c65"
        />
      </svg>
    );
  },
  powerOff: function () {
    return (
      <svg
        height="30"
        width="30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        fill="#000000"
        transform="rotate(180)"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="SVGRepo_iconCarrier"> 
          <path
            style={{fill:'#b8b8b8'}}
            d="M321.628,446.372c-63.339,0-122.346-31.372-157.846-83.917c-7.196-10.651-4.394-25.117,6.256-32.313 c10.654-7.194,25.117-4.394,32.313,6.256c26.832,39.717,71.421,63.429,119.277,63.429c79.306,0,143.827-64.521,143.827-143.827 c0-79.307-64.521-143.827-143.827-143.827c-47.998,0-92.66,23.819-119.471,63.716c-7.173,10.67-21.63,13.504-32.298,6.335 c-10.667-7.17-13.503-21.63-6.335-32.298c35.475-52.784,94.579-84.298,158.104-84.298C426.598,65.628,512,151.028,512,256 C512,360.971,426.598,446.372,321.628,446.372z"
          />
          <path
            style={{fill:'#f06638'}}
            d="M349.088,232.727H79.458l30.09-30.089c9.089-9.089,9.089-23.824,0-32.912 c-9.087-9.087-23.824-9.087-32.912,0L6.817,239.543c-0.034,0.034-0.062,0.071-0.096,0.105c-0.498,0.504-0.977,1.029-1.429,1.578 c-0.14,0.169-0.258,0.351-0.391,0.523c-0.334,0.428-0.667,0.858-0.97,1.309c-0.099,0.152-0.185,0.313-0.284,0.467 c-0.31,0.489-0.616,0.979-0.892,1.491c-0.061,0.112-0.106,0.231-0.166,0.344c-0.289,0.562-0.568,1.13-0.81,1.716 c-0.033,0.079-0.057,0.163-0.092,0.244c-0.248,0.621-0.483,1.251-0.678,1.898c-0.026,0.087-0.042,0.175-0.067,0.262 c-0.186,0.638-0.355,1.28-0.487,1.939c-0.039,0.199-0.057,0.402-0.092,0.602c-0.096,0.548-0.192,1.095-0.248,1.655 C0.04,254.445,0,255.221,0,256c0,0.779,0.04,1.555,0.116,2.324c0.057,0.568,0.155,1.122,0.251,1.676 c0.034,0.192,0.048,0.389,0.088,0.58c0.133,0.669,0.306,1.322,0.493,1.969c0.023,0.076,0.036,0.157,0.061,0.233 c0.2,0.656,0.436,1.297,0.69,1.93c0.028,0.068,0.048,0.141,0.076,0.209c0.25,0.6,0.534,1.181,0.83,1.753 c0.051,0.101,0.095,0.206,0.147,0.307c0.285,0.529,0.602,1.038,0.923,1.542c0.088,0.137,0.163,0.281,0.251,0.414 c0.321,0.479,0.673,0.936,1.029,1.389c0.113,0.146,0.214,0.299,0.332,0.442c0.483,0.588,0.995,1.153,1.53,1.691l69.815,69.814 c4.544,4.544,10.501,6.817,16.457,6.817s11.913-2.273,16.455-6.817c9.089-9.089,9.089-23.824,0-32.912l-30.089-30.089h269.63 c12.853,0,23.273-10.42,23.273-23.273S361.941,232.727,349.088,232.727z"
          />
        </g>
      </svg>
    );
  },
  IndicatorClose: function () {
    return (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="5" fill="#439A97" fillOpacity="0.08" />
        <g filter="url(#filter0_d_0_1)">
          <circle cx="15.5" cy="15.5" r="7.5" fill="#DC3535" />
        </g>
        <defs>
          <filter
            id="filter0_d_0_1"
            x="2"
            y="4"
            width="27"
            height="27"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_0_1"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_0_1"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  },
  IndicatorOpen: function () {
    return (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="5" fill="#439A97" fillOpacity="0.08" />
        <g filter="url(#filter0_d_0_1)">
          <circle cx="15.5" cy="15.5" r="7.5" fill="#7BC882" />
        </g>
        <defs>
          <filter
            id="filter0_d_0_1"
            x="2"
            y="4"
            width="27"
            height="27"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_0_1"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_0_1"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  },
  ScanQrIcon: function () {
    return (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_0_1)">
          <circle cx="31" cy="29" r="25" fill="rgba(var(--bs-success-rgb)" />
        </g>
        <path
          d="M36.8333 20.6C36.7045 20.6 36.6 20.7045 36.6 20.8333V23.1667C36.6 23.2955 36.7045 23.4 36.8333 23.4H39.1667C39.2955 23.4 39.4 23.2955 39.4 23.1667V20.8333C39.4 20.7045 39.2955 20.6 39.1667 20.6H36.8333ZM36.6 37.4V36.7C36.6 36.3134 36.9134 36 37.3 36C37.6866 36 38 36.3134 38 36.7V37.4H39.4V36.7C39.4 36.3134 39.7134 36 40.1 36C40.4866 36 40.8 36.3134 40.8 36.7V38.1C40.8 38.4866 40.4866 38.8 40.1 38.8H34.5C34.1134 38.8 33.8 38.4866 33.8 38.1V36.7C33.8 36.3134 34.1134 36 34.5 36C34.8866 36 35.2 36.3134 35.2 36.7V37.4H36.6ZM32.4 27.6H33.1C33.4866 27.6 33.8 27.9134 33.8 28.3C33.8 28.6866 33.4866 29 33.1 29H30.3C29.9134 29 29.6 28.6866 29.6 28.3C29.6 27.9134 29.9134 27.6 30.3 27.6H31V26.2H28.9C28.5134 26.2 28.2 25.8866 28.2 25.5C28.2 25.1134 28.5134 24.8 28.9 24.8H33.1C33.4866 24.8 33.8 25.1134 33.8 25.5C33.8 25.8866 33.4866 26.2 33.1 26.2H32.4V27.6ZM39.4 29H38.7C38.3134 29 38 28.6866 38 28.3C38 27.9134 38.3134 27.6 38.7 27.6H39.4V26.9C39.4 26.5134 39.7134 26.2 40.1 26.2C40.4866 26.2 40.8 26.5134 40.8 26.9V29.7C40.8 30.0866 40.4866 30.4 40.1 30.4C39.7134 30.4 39.4 30.0866 39.4 29.7V29ZM32.4 31.8H31.7C31.3134 31.8 31 31.4866 31 31.1C31 30.7134 31.3134 30.4 31.7 30.4H33.1C33.4866 30.4 33.8 30.7134 33.8 31.1V33.9C33.8 34.2866 33.4866 34.6 33.1 34.6H28.9C28.5134 34.6 28.2 34.2866 28.2 33.9C28.2 33.5134 28.5134 33.2 28.9 33.2H32.4V31.8ZM36.8333 19.2H39.1667C40.0687 19.2 40.8 19.9313 40.8 20.8333V23.1667C40.8 24.0687 40.0687 24.8 39.1667 24.8H36.8333C35.9313 24.8 35.2 24.0687 35.2 23.1667V20.8333C35.2 19.9313 35.9313 19.2 36.8333 19.2ZM22.8333 19.2H25.1667C26.0687 19.2 26.8 19.9313 26.8 20.8333V23.1667C26.8 24.0687 26.0687 24.8 25.1667 24.8H22.8333C21.9313 24.8 21.2 24.0687 21.2 23.1667V20.8333C21.2 19.9313 21.9313 19.2 22.8333 19.2ZM22.8333 20.6C22.7045 20.6 22.6 20.7045 22.6 20.8333V23.1667C22.6 23.2955 22.7045 23.4 22.8333 23.4H25.1667C25.2955 23.4 25.4 23.2955 25.4 23.1667V20.8333C25.4 20.7045 25.2955 20.6 25.1667 20.6H22.8333ZM22.8333 33.2H25.1667C26.0687 33.2 26.8 33.9313 26.8 34.8333V37.1667C26.8 38.0687 26.0687 38.8 25.1667 38.8H22.8333C21.9313 38.8 21.2 38.0687 21.2 37.1667V34.8333C21.2 33.9313 21.9313 33.2 22.8333 33.2ZM22.8333 34.6C22.7045 34.6 22.6 34.7045 22.6 34.8333V37.1667C22.6 37.2955 22.7045 37.4 22.8333 37.4H25.1667C25.2955 37.4 25.4 37.2955 25.4 37.1667V34.8333C25.4 34.7045 25.2955 34.6 25.1667 34.6H22.8333ZM32.4 20.6H28.9C28.5134 20.6 28.2 20.2866 28.2 19.9C28.2 19.5134 28.5134 19.2 28.9 19.2H33.1C33.4866 19.2 33.8 19.5134 33.8 19.9V22.7C33.8 23.0866 33.4866 23.4 33.1 23.4C32.7134 23.4 32.4 23.0866 32.4 22.7V20.6ZM28.9 23.4C28.5134 23.4 28.2 23.0866 28.2 22.7C28.2 22.3134 28.5134 22 28.9 22H30.3C30.6866 22 31 22.3134 31 22.7C31 23.0866 30.6866 23.4 30.3 23.4H28.9ZM21.9 31.8C21.5134 31.8 21.2 31.4866 21.2 31.1C21.2 30.7134 21.5134 30.4 21.9 30.4H24.7C25.0866 30.4 25.4 30.7134 25.4 31.1C25.4 31.4866 25.0866 31.8 24.7 31.8H21.9ZM27.5 31.8C27.1134 31.8 26.8 31.4866 26.8 31.1C26.8 30.7134 27.1134 30.4 27.5 30.4H28.9C29.2866 30.4 29.6 30.7134 29.6 31.1C29.6 31.4866 29.2866 31.8 28.9 31.8H27.5ZM29.6 37.4V38.1C29.6 38.4866 29.2866 38.8 28.9 38.8C28.5134 38.8 28.2 38.4866 28.2 38.1V36.7C28.2 36.3134 28.5134 36 28.9 36H31.7C32.0866 36 32.4 36.3134 32.4 36.7C32.4 37.0866 32.0866 37.4 31.7 37.4H29.6ZM26.8 27.6H27.5C27.8866 27.6 28.2 27.9134 28.2 28.3C28.2 28.6866 27.8866 29 27.5 29H26.1C25.7134 29 25.4 28.6866 25.4 28.3V27.6H24.7C24.3134 27.6 24 27.2866 24 26.9C24 26.5134 24.3134 26.2 24.7 26.2H26.1C26.4866 26.2 26.8 26.5134 26.8 26.9V27.6ZM21.2 26.9C21.2 26.5134 21.5134 26.2 21.9 26.2C22.2866 26.2 22.6 26.5134 22.6 26.9V28.3C22.6 28.6866 22.2866 29 21.9 29C21.5134 29 21.2 28.6866 21.2 28.3V26.9ZM35.2 26.9C35.2 26.5134 35.5134 26.2 35.9 26.2C36.2866 26.2 36.6 26.5134 36.6 26.9V29.7C36.6 30.0866 36.2866 30.4 35.9 30.4C35.5134 30.4 35.2 30.0866 35.2 29.7V26.9ZM38 33.2V32.5C38 32.1134 38.3134 31.8 38.7 31.8H40.1C40.4866 31.8 40.8 32.1134 40.8 32.5C40.8 32.8866 40.4866 33.2 40.1 33.2H39.4V33.9C39.4 34.2866 39.0866 34.6 38.7 34.6H35.9C35.5134 34.6 35.2 34.2866 35.2 33.9V32.5C35.2 32.1134 35.5134 31.8 35.9 31.8C36.2866 31.8 36.6 32.1134 36.6 32.5V33.2H38ZM18.4 21.3C18.4 21.6866 18.0866 22 17.7 22C17.3134 22 17 21.6866 17 21.3V18.5C17 16.567 18.567 15 20.5 15H23.3C23.6866 15 24 15.3134 24 15.7C24 16.0866 23.6866 16.4 23.3 16.4H20.5C19.3402 16.4 18.4 17.3402 18.4 18.5V21.3ZM38.7 16.4C38.3134 16.4 38 16.0866 38 15.7C38 15.3134 38.3134 15 38.7 15H41.5C43.433 15 45 16.567 45 18.5V21.3C45 21.6866 44.6866 22 44.3 22C43.9134 22 43.6 21.6866 43.6 21.3V18.5C43.6 17.3402 42.6598 16.4 41.5 16.4H38.7ZM23.3 41.6C23.6866 41.6 24 41.9134 24 42.3C24 42.6866 23.6866 43 23.3 43H20.5C18.567 43 17 41.433 17 39.5V36.7C17 36.3134 17.3134 36 17.7 36C18.0866 36 18.4 36.3134 18.4 36.7V39.5C18.4 40.6598 19.3402 41.6 20.5 41.6H23.3ZM43.6 36.7C43.6 36.3134 43.9134 36 44.3 36C44.6866 36 45 36.3134 45 36.7V39.5C45 41.433 43.433 43 41.5 43H38.7C38.3134 43 38 42.6866 38 42.3C38 41.9134 38.3134 41.6 38.7 41.6H41.5C42.6598 41.6 43.6 40.6598 43.6 39.5V36.7Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_0_1"
            x="0"
            y="0"
            width="62"
            height="62"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_0_1"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_0_1"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  },
  ArrowLeft: function () {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        width="18"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.66088 8.53078C9.95402 8.23813 9.95442 7.76326 9.66178 7.47012C9.36913 7.17698 8.89426 7.17658 8.60112 7.46922L9.66088 8.53078ZM4.47012 11.5932C4.17698 11.8859 4.17658 12.3607 4.46922 12.6539C4.76187 12.947 5.23674 12.9474 5.52988 12.6548L4.47012 11.5932ZM5.51318 11.5771C5.21111 11.2936 4.73648 11.3088 4.45306 11.6108C4.16964 11.9129 4.18475 12.3875 4.48682 12.6709L5.51318 11.5771ZM8.61782 16.5469C8.91989 16.8304 9.39452 16.8152 9.67794 16.5132C9.96136 16.2111 9.94625 15.7365 9.64418 15.4531L8.61782 16.5469ZM5 11.374C4.58579 11.374 4.25 11.7098 4.25 12.124C4.25 12.5382 4.58579 12.874 5 12.874V11.374ZM15.37 12.124V12.874L15.3723 12.874L15.37 12.124ZM17.9326 13.1766L18.4614 12.6447V12.6447L17.9326 13.1766ZM18.25 15.7351C18.2511 16.1493 18.5879 16.4841 19.0021 16.483C19.4163 16.4819 19.7511 16.1451 19.75 15.7309L18.25 15.7351ZM8.60112 7.46922L4.47012 11.5932L5.52988 12.6548L9.66088 8.53078L8.60112 7.46922ZM4.48682 12.6709L8.61782 16.5469L9.64418 15.4531L5.51318 11.5771L4.48682 12.6709ZM5 12.874H15.37V11.374H5V12.874ZM15.3723 12.874C16.1333 12.8717 16.8641 13.1718 17.4038 13.7084L18.4614 12.6447C17.6395 11.8276 16.5267 11.3705 15.3677 11.374L15.3723 12.874ZM17.4038 13.7084C17.9435 14.245 18.2479 14.974 18.25 15.7351L19.75 15.7309C19.7468 14.572 19.2833 13.4618 18.4614 12.6447L17.4038 13.7084Z"
          fill="#000000"
        />
      </svg>
    );
  },
  Searching: function () {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 -0.5 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.30524 15.7137C6.4404 14.8306 5.85381 13.7131 5.61824 12.4997C5.38072 11.2829 5.50269 10.0233 5.96924 8.87469C6.43181 7.73253 7.22153 6.75251 8.23924 6.05769C10.3041 4.64744 13.0224 4.64744 15.0872 6.05769C16.105 6.75251 16.8947 7.73253 17.3572 8.87469C17.8238 10.0233 17.9458 11.2829 17.7082 12.4997C17.4727 13.7131 16.8861 14.8306 16.0212 15.7137C14.8759 16.889 13.3044 17.5519 11.6632 17.5519C10.0221 17.5519 8.45059 16.889 7.30524 15.7137V15.7137Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6702 7.20292C11.2583 7.24656 10.9598 7.61586 11.0034 8.02777C11.0471 8.43968 11.4164 8.73821 11.8283 8.69457L11.6702 7.20292ZM13.5216 9.69213C13.6831 10.0736 14.1232 10.2519 14.5047 10.0904C14.8861 9.92892 15.0644 9.4888 14.9029 9.10736L13.5216 9.69213ZM16.6421 15.0869C16.349 14.7943 15.8741 14.7947 15.5815 15.0879C15.2888 15.381 15.2893 15.8559 15.5824 16.1485L16.6421 15.0869ZM18.9704 19.5305C19.2636 19.8232 19.7384 19.8228 20.0311 19.5296C20.3237 19.2364 20.3233 18.7616 20.0301 18.4689L18.9704 19.5305ZM11.8283 8.69457C12.5508 8.61801 13.2384 9.02306 13.5216 9.69213L14.9029 9.10736C14.3622 7.83005 13.0496 7.05676 11.6702 7.20292L11.8283 8.69457ZM15.5824 16.1485L18.9704 19.5305L20.0301 18.4689L16.6421 15.0869L15.5824 16.1485Z"
          fill="#000000"
        />
      </svg>
    );
  },
  ArrowRight: function () {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ionicon"
        width="18"
        height="18"
        viewBox="0 0 512 512"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="48"
          d="M184 112l144 144-144 144"
        />
      </svg>
    );
  },
  SettingsIcon: function () {
    return (
      <svg
        width="38"
        height="38"
        viewBox="0 0 20 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.755 0C11.551 0 12.2718 0.462 12.6698 1.144C12.8634 1.474 12.9925 1.881 12.9603 2.31C12.9387 2.64 13.0356 2.97 13.2077 3.278C13.7563 4.213 14.9719 4.565 15.9185 4.037C16.9835 3.399 18.3282 3.784 18.9414 4.873L19.6621 6.171C20.2861 7.26 19.9418 8.657 18.8661 9.284C17.9517 9.845 17.629 11.088 18.1776 12.034C18.3497 12.331 18.5434 12.584 18.8446 12.738C19.2211 12.947 19.5115 13.277 19.7159 13.607C20.114 14.289 20.0817 15.125 19.6944 15.862L18.9414 17.182C18.5434 17.886 17.8011 18.326 17.0373 18.326C16.6608 18.326 16.2413 18.216 15.897 17.996C15.6173 17.809 15.2946 17.743 14.9504 17.743C13.8854 17.743 12.9925 18.656 12.9603 19.745C12.9603 21.01 11.9706 22 10.7335 22H9.27045C8.02258 22 7.0329 21.01 7.0329 19.745C7.01138 18.656 6.11852 17.743 5.05353 17.743C4.69853 17.743 4.37581 17.809 4.10687 17.996C3.76263 18.216 3.33234 18.326 2.96658 18.326C2.19205 18.326 1.44978 17.886 1.05176 17.182L0.309495 15.862C-0.088531 15.147 -0.110046 14.289 0.28798 13.607C0.460099 13.277 0.782822 12.947 1.14858 12.738C1.44978 12.584 1.64342 12.331 1.82629 12.034C2.36417 11.088 2.04144 9.845 1.12706 9.284C0.0620733 8.657 -0.282165 7.26 0.331009 6.171L1.05176 4.873C1.67569 3.784 3.00961 3.399 4.08536 4.037C5.02126 4.565 6.23685 4.213 6.78548 3.278C6.9576 2.97 7.05441 2.64 7.0329 2.31C7.01138 1.881 7.12972 1.474 7.33411 1.144C7.73213 0.462 8.45288 0.022 9.23818 0H10.755ZM10.0127 7.898C8.32379 7.898 6.9576 9.284 6.9576 11.011C6.9576 12.738 8.32379 14.113 10.0127 14.113C11.7016 14.113 13.0356 12.738 13.0356 11.011C13.0356 9.284 11.7016 7.898 10.0127 7.898Z"
          fill="#052c65"
          fillOpacity="0.4"
        />
      </svg>
    );
  },
  HomeIcon: function () {
    return (
      <svg
        width="29"
        height="29"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.98398 18.7733V15.7156C6.98398 14.9351 7.65492 14.3023 8.48256 14.3023H11.508C11.9055 14.3023 12.2866 14.4512 12.5677 14.7162C12.8487 14.9813 13.0066 15.3408 13.0066 15.7156V18.7733C13.0041 19.0978 13.139 19.4099 13.3814 19.6402C13.6239 19.8705 13.9537 20 14.2978 20H16.3619C17.3259 20.0023 18.2513 19.6428 18.9339 19.0008C19.6164 18.3588 20 17.487 20 16.5778V7.86685C20 7.13246 19.6548 6.43584 19.0575 5.96467L12.0358 0.675869C10.8144 -0.251438 9.06433 -0.221498 7.87936 0.746979L1.01791 5.96467C0.392359 6.42195 0.0184761 7.12063 0 7.86685V16.5689C0 18.4638 1.62882 20 3.63808 20H5.65504C6.36971 20 6.95052 19.4562 6.9557 18.7822L6.98398 18.7733Z"
          fill="#768599"
        />
      </svg>
    );
  },
  pendingIcon: function () {
    return (
      <svg
        id="Layer_1"
        width="25"
        height="25"
        fill="var(--bs-orange)"
        dataName="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 122.88 121.86"
      >
        <title>time-expiration</title>
        <path
          style={{ fillRule: "evenodd" }}
          d="M61.8,84.86,86.45,41.41c3.12-4.93,8.09-5.06,11.28,0l24.21,42.91c2,4.07,1,9.54-5.58,9.43H67c-4.35.11-7.15-3.7-5.17-8.89ZM45.73,64.07V51.49a4.06,4.06,0,0,1-1.26-1.58l-8.6-4.28a1.59,1.59,0,0,1-.9,1.08,1.64,1.64,0,0,1-2.19-.79l-2-4.18a1.65,1.65,0,0,1,0-1.27v0h0v0h0a1.65,1.65,0,0,1,1.23-1l4.54-.84a1.64,1.64,0,0,1,1.92,1.33,1.62,1.62,0,0,1-.33,1.32L45.69,45a4.11,4.11,0,1,1,5,6.53V64.07a1.61,1.61,0,0,1,1.36.31,1.64,1.64,0,0,1,.3,2.32l-2.82,3.65a1.67,1.67,0,0,1-1.3.65h0a1.67,1.67,0,0,1-1.3-.65L44.07,66.7a1.64,1.64,0,0,1,.3-2.32,1.61,1.61,0,0,1,1.36-.31ZM16.57,45.5a2.71,2.71,0,0,1,0,5.42h-3a2.71,2.71,0,1,1,0-5.42ZM45.5,80.26a2.71,2.71,0,1,1,5.42,0v2.95a2.71,2.71,0,1,1-5.42,0V80.26Zm0-66.66a2.71,2.71,0,0,1,5.42,0v3a2.71,2.71,0,1,1-5.42,0v-3ZM26.79,19.82a2.7,2.7,0,0,1,4.68-2.69L33,19.7a2.7,2.7,0,1,1-4.68,2.69l-1.48-2.57Zm37.53-2.35A2.7,2.7,0,0,1,69,20.16l-1.48,2.57A2.7,2.7,0,1,1,62.84,20l1.48-2.57Zm-49,16.1A2.7,2.7,0,0,1,18,28.88l2.57,1.49a2.7,2.7,0,0,1-2.7,4.68l-2.56-1.48Zm63.19-4.69a2.7,2.7,0,1,1,2.69,4.69l-2.57,1.48a2.7,2.7,0,0,1-2.69-4.68l2.57-1.49ZM19.55,69.13a2.7,2.7,0,0,1-2.69-4.68L19.43,63a2.7,2.7,0,1,1,2.69,4.68l-2.57,1.48ZM32,79.56a2.7,2.7,0,0,1-4.68-2.69l1.48-2.57A2.7,2.7,0,1,1,33.45,77L32,79.56ZM48.21,0A48.26,48.26,0,0,1,92.94,30.19q-.42,0-.84,0a10.51,10.51,0,0,0-4,.82A43.41,43.41,0,1,0,48.21,91.61a44.39,44.39,0,0,0,5.44-.34,10.71,10.71,0,0,0,1.71,4.26l.23.33a48.56,48.56,0,0,1-7.38.56A48.21,48.21,0,1,1,48.21,0ZM89.7,81a3.32,3.32,0,0,1,3.51-.73,3.45,3.45,0,0,1,1.21.78,3.31,3.31,0,0,1,1,2.12,3.39,3.39,0,0,1,0,.84A3.33,3.33,0,0,1,92,86.72a3.52,3.52,0,0,1-1.36-.32A3.35,3.35,0,0,1,89,81.89,3,3,0,0,1,89.7,81Zm4.88-6.12c-.12,2.87-5,2.87-5.08,0C89,69.92,87.75,60.59,87.79,56c.11-3.72,8.49-3.62,8.49.08v.14l-1.7,18.64Z"
        />
      </svg>
    );
  },
  complatedIcon: function () {
    return (
      <svg
        id="Layer_1"
        width="24"
        height="24"
        fill="var(--bs-success)"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 122.88 121.86"
        enableBackground="new 0 0 122.88 121.86"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.44,0.01c3.27-0.14,5.85,1,8.45,2.65c3.3,2.09,7.02,6.23,11.61,8.85c6.45,3.69,18.41-1.4,24.53,7.7 c3.57,5.3,3.74,9.46,4,13.57c0.29,4.43,1.06,8.51,5.6,14.51c7.51,9.93,9.07,16.54,5.2,23.43c-2.64,4.7-8.19,7.31-9.48,10.28 c-2.73,6.33,0.29,11.1-3.45,18.48c-2.6,5.12-6.61,8.49-11.95,10.21c-4.5,1.45-9.03-0.65-12.63,0.87 c-6.34,2.66-11.01,8.85-16.06,10.42c-1.95,0.6-3.89,0.9-5.82,0.89c-1.94,0.01-3.88-0.28-5.82-0.89 c-5.04-1.57-9.72-7.75-16.06-10.42c-3.61-1.52-8.13,0.58-12.63-0.87c-5.34-1.72-9.35-5.09-11.95-10.21 C11.23,92.1,14.26,87.33,11.52,81c-1.29-2.97-6.84-5.58-9.48-10.28c-3.87-6.89-2.3-13.5,5.2-23.43c4.54-6,5.31-10.08,5.6-14.51 c0.27-4.11,0.43-8.27,4-13.57c6.12-9.1,18.08-4.01,24.53-7.7c4.59-2.62,8.3-6.76,11.61-8.85C55.59,1.01,58.17-0.13,61.44,0.01 L61.44,0.01z M50.83,53.9l7.86,7.48l13.53-13.75c1.34-1.36,2.18-2.45,3.83-0.75l5.36,5.49c1.76,1.74,1.67,2.76,0.01,4.38 L61.75,76.06c-3.5,3.43-2.89,3.64-6.44,0.12L41.81,62.75c-0.74-0.8-0.66-1.61,0.15-2.41l6.22-6.45 C49.11,52.91,49.86,52.97,50.83,53.9L50.83,53.9z M61.26,27.57c18.95,0,34.3,15.36,34.3,34.3c0,18.95-15.36,34.3-34.3,34.3 c-18.95,0-34.3-15.36-34.3-34.3C26.96,42.92,42.32,27.57,61.26,27.57L61.26,27.57z"
        />
      </svg>
    );
  },
  checkIcon: function () {
    return (
      <svg
        id="Layer_1"
        width="24"
        height="24"
        fill="var(--bs-info)"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 122.88 122.88"
        enableBackground="new 0 0 122.88 122.88"
      >
        <path d="M34.388,67.984c-0.286-0.308-0.542-0.638-0.762-0.981c-0.221-0.345-0.414-0.714-0.573-1.097 c-0.531-1.265-0.675-2.631-0.451-3.934c0.224-1.294,0.812-2.531,1.744-3.548l0.34-0.35c2.293-2.185,5.771-2.592,8.499-0.951 c0.39,0.233,0.762,0.51,1.109,0.827l0.034,0.031c1.931,1.852,5.198,4.881,7.343,6.79l1.841,1.651l22.532-23.635 c0.317-0.327,0.666-0.62,1.035-0.876c0.378-0.261,0.775-0.482,1.185-0.661c0.414-0.181,0.852-0.323,1.3-0.421 c0.447-0.099,0.903-0.155,1.356-0.165h0.026c0.451-0.005,0.893,0.027,1.341,0.103c0.437,0.074,0.876,0.193,1.333,0.369 c0.421,0.161,0.825,0.363,1.207,0.604c0.365,0.231,0.721,0.506,1.056,0.822l0.162,0.147c0.316,0.313,0.601,0.653,0.85,1.014 c0.256,0.369,0.475,0.766,0.652,1.178c0.183,0.414,0.325,0.852,0.424,1.299c0.1,0.439,0.154,0.895,0.165,1.36v0.23 c-0.004,0.399-0.042,0.804-0.114,1.204c-0.079,0.435-0.198,0.863-0.356,1.271c-0.16,0.418-0.365,0.825-0.607,1.21 c-0.238,0.377-0.518,0.739-0.832,1.07l-27.219,28.56c-0.32,0.342-0.663,0.642-1.022,0.898c-0.369,0.264-0.767,0.491-1.183,0.681 c-0.417,0.188-0.851,0.337-1.288,0.44c-0.435,0.104-0.889,0.166-1.35,0.187l-0.125,0.003c-0.423,0.009-0.84-0.016-1.241-0.078 l-0.102-0.02c-0.415-0.07-0.819-0.174-1.205-0.31c-0.421-0.15-0.833-0.343-1.226-0.575l-0.063-0.04 c-0.371-0.224-0.717-0.477-1.032-0.754l-0.063-0.06c-1.58-1.466-3.297-2.958-5.033-4.466c-3.007-2.613-7.178-6.382-9.678-9.02 L34.388,67.984L34.388,67.984z M61.44,0c16.96,0,32.328,6.883,43.453,17.987c11.104,11.125,17.986,26.493,17.986,43.453 c0,16.961-6.883,32.329-17.986,43.454C93.769,115.998,78.4,122.88,61.44,122.88c-16.961,0-32.329-6.882-43.454-17.986 C6.882,93.769,0,78.4,0,61.439C0,44.48,6.882,29.112,17.986,17.987C29.112,6.883,44.479,0,61.44,0L61.44,0z M96.899,25.981 C87.826,16.907,75.29,11.296,61.44,11.296c-13.851,0-26.387,5.611-35.46,14.685c-9.073,9.073-14.684,21.609-14.684,35.458 c0,13.851,5.611,26.387,14.684,35.46s21.609,14.685,35.46,14.685c13.85,0,26.386-5.611,35.459-14.685s14.684-21.609,14.684-35.46 C111.583,47.59,105.973,35.054,96.899,25.981L96.899,25.981z" />
      </svg>
    );
  },
  QrCode: function () {
    return (
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.4167 10C35.1865 10 35 10.1865 35 10.4167V14.5833C35 14.8135 35.1865 15 35.4167 15H39.5833C39.8135 15 40 14.8135 40 14.5833V10.4167C40 10.1865 39.8135 10 39.5833 10H35.4167ZM35 40V38.75C35 38.0596 35.5596 37.5 36.25 37.5C36.9404 37.5 37.5 38.0596 37.5 38.75V40H40V38.75C40 38.0596 40.5596 37.5 41.25 37.5C41.9404 37.5 42.5 38.0596 42.5 38.75V41.25C42.5 41.9404 41.9404 42.5 41.25 42.5H31.25C30.5596 42.5 30 41.9404 30 41.25V38.75C30 38.0596 30.5596 37.5 31.25 37.5C31.9404 37.5 32.5 38.0596 32.5 38.75V40H35ZM27.5 22.5H28.75C29.4404 22.5 30 23.0596 30 23.75C30 24.4404 29.4404 25 28.75 25H23.75C23.0596 25 22.5 24.4404 22.5 23.75C22.5 23.0596 23.0596 22.5 23.75 22.5H25V20H21.25C20.5596 20 20 19.4404 20 18.75C20 18.0596 20.5596 17.5 21.25 17.5H28.75C29.4404 17.5 30 18.0596 30 18.75C30 19.4404 29.4404 20 28.75 20H27.5V22.5ZM40 25H38.75C38.0596 25 37.5 24.4404 37.5 23.75C37.5 23.0596 38.0596 22.5 38.75 22.5H40V21.25C40 20.5596 40.5596 20 41.25 20C41.9404 20 42.5 20.5596 42.5 21.25V26.25C42.5 26.9404 41.9404 27.5 41.25 27.5C40.5596 27.5 40 26.9404 40 26.25V25ZM27.5 30H26.25C25.5596 30 25 29.4404 25 28.75C25 28.0596 25.5596 27.5 26.25 27.5H28.75C29.4404 27.5 30 28.0596 30 28.75V33.75C30 34.4404 29.4404 35 28.75 35H21.25C20.5596 35 20 34.4404 20 33.75C20 33.0596 20.5596 32.5 21.25 32.5H27.5V30ZM35.4167 7.5H39.5833C41.1942 7.5 42.5 8.80584 42.5 10.4167V14.5833C42.5 16.1942 41.1942 17.5 39.5833 17.5H35.4167C33.8058 17.5 32.5 16.1942 32.5 14.5833V10.4167C32.5 8.80584 33.8058 7.5 35.4167 7.5ZM10.4167 7.5H14.5833C16.1942 7.5 17.5 8.80584 17.5 10.4167V14.5833C17.5 16.1942 16.1942 17.5 14.5833 17.5H10.4167C8.80584 17.5 7.5 16.1942 7.5 14.5833V10.4167C7.5 8.80584 8.80584 7.5 10.4167 7.5ZM10.4167 10C10.1865 10 10 10.1865 10 10.4167V14.5833C10 14.8135 10.1865 15 10.4167 15H14.5833C14.8135 15 15 14.8135 15 14.5833V10.4167C15 10.1865 14.8135 10 14.5833 10H10.4167ZM10.4167 32.5H14.5833C16.1942 32.5 17.5 33.8058 17.5 35.4167V39.5833C17.5 41.1942 16.1942 42.5 14.5833 42.5H10.4167C8.80584 42.5 7.5 41.1942 7.5 39.5833V35.4167C7.5 33.8058 8.80584 32.5 10.4167 32.5ZM10.4167 35C10.1865 35 10 35.1865 10 35.4167V39.5833C10 39.8135 10.1865 40 10.4167 40H14.5833C14.8135 40 15 39.8135 15 39.5833V35.4167C15 35.1865 14.8135 35 14.5833 35H10.4167ZM27.5 10H21.25C20.5596 10 20 9.44036 20 8.75C20 8.05964 20.5596 7.5 21.25 7.5H28.75C29.4404 7.5 30 8.05964 30 8.75V13.75C30 14.4404 29.4404 15 28.75 15C28.0596 15 27.5 14.4404 27.5 13.75V10ZM21.25 15C20.5596 15 20 14.4404 20 13.75C20 13.0596 20.5596 12.5 21.25 12.5H23.75C24.4404 12.5 25 13.0596 25 13.75C25 14.4404 24.4404 15 23.75 15H21.25ZM8.75 30C8.05964 30 7.5 29.4404 7.5 28.75C7.5 28.0596 8.05964 27.5 8.75 27.5H13.75C14.4404 27.5 15 28.0596 15 28.75C15 29.4404 14.4404 30 13.75 30H8.75ZM18.75 30C18.0596 30 17.5 29.4404 17.5 28.75C17.5 28.0596 18.0596 27.5 18.75 27.5H21.25C21.9404 27.5 22.5 28.0596 22.5 28.75C22.5 29.4404 21.9404 30 21.25 30H18.75ZM22.5 40V41.25C22.5 41.9404 21.9404 42.5 21.25 42.5C20.5596 42.5 20 41.9404 20 41.25V38.75C20 38.0596 20.5596 37.5 21.25 37.5H26.25C26.9404 37.5 27.5 38.0596 27.5 38.75C27.5 39.4404 26.9404 40 26.25 40H22.5ZM17.5 22.5H18.75C19.4404 22.5 20 23.0596 20 23.75C20 24.4404 19.4404 25 18.75 25H16.25C15.5596 25 15 24.4404 15 23.75V22.5H13.75C13.0596 22.5 12.5 21.9404 12.5 21.25C12.5 20.5596 13.0596 20 13.75 20H16.25C16.9404 20 17.5 20.5596 17.5 21.25V22.5ZM7.5 21.25C7.5 20.5596 8.05964 20 8.75 20C9.44036 20 10 20.5596 10 21.25V23.75C10 24.4404 9.44036 25 8.75 25C8.05964 25 7.5 24.4404 7.5 23.75V21.25ZM32.5 21.25C32.5 20.5596 33.0596 20 33.75 20C34.4404 20 35 20.5596 35 21.25V26.25C35 26.9404 34.4404 27.5 33.75 27.5C33.0596 27.5 32.5 26.9404 32.5 26.25V21.25ZM37.5 32.5V31.25C37.5 30.5596 38.0596 30 38.75 30H41.25C41.9404 30 42.5 30.5596 42.5 31.25C42.5 31.9404 41.9404 32.5 41.25 32.5H40V33.75C40 34.4404 39.4404 35 38.75 35H33.75C33.0596 35 32.5 34.4404 32.5 33.75V31.25C32.5 30.5596 33.0596 30 33.75 30C34.4404 30 35 30.5596 35 31.25V32.5H37.5ZM2.5 11.25C2.5 11.9404 1.94036 12.5 1.25 12.5C0.559644 12.5 0 11.9404 0 11.25V6.25C0 2.79822 2.79822 0 6.25 0H11.25C11.9404 0 12.5 0.559644 12.5 1.25C12.5 1.94036 11.9404 2.5 11.25 2.5H6.25C4.17893 2.5 2.5 4.17893 2.5 6.25V11.25ZM38.75 2.5C38.0596 2.5 37.5 1.94036 37.5 1.25C37.5 0.559644 38.0596 0 38.75 0H43.75C47.2018 0 50 2.79822 50 6.25V11.25C50 11.9404 49.4404 12.5 48.75 12.5C48.0596 12.5 47.5 11.9404 47.5 11.25V6.25C47.5 4.17893 45.8211 2.5 43.75 2.5H38.75ZM11.25 47.5C11.9404 47.5 12.5 48.0596 12.5 48.75C12.5 49.4404 11.9404 50 11.25 50H6.25C2.79822 50 0 47.2018 0 43.75V38.75C0 38.0596 0.559644 37.5 1.25 37.5C1.94036 37.5 2.5 38.0596 2.5 38.75V43.75C2.5 45.8211 4.17893 47.5 6.25 47.5H11.25ZM47.5 38.75C47.5 38.0596 48.0596 37.5 48.75 37.5C49.4404 37.5 50 38.0596 50 38.75V43.75C50 47.2018 47.2018 50 43.75 50H38.75C38.0596 50 37.5 49.4404 37.5 48.75C37.5 48.0596 38.0596 47.5 38.75 47.5H43.75C45.8211 47.5 47.5 45.8211 47.5 43.75V38.75Z"
          fill="white"
        />
      </svg>
    );
  },
  Edit: function () {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 19.9998H9L19.5 9.49981C20.0304 8.96938 20.3284 8.24996 20.3284 7.49981C20.3284 6.74967 20.0304 6.03025 19.5 5.49981C18.9696 4.96938 18.2501 4.67139 17.5 4.67139C16.7499 4.67139 16.0304 4.96938 15.5 5.49981L5 15.9998V19.9998Z"
          stroke="#A4A4A4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 6.49982L18.5 10.4998"
          stroke="#A4A4A4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  BackIcon: function () {
    return (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.94972 9L18.75 9"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M8.3081 16.0287L1.24977 9.00066L8.30811 1.9715"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </svg>
    );
  },
  Back: function () {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.6665 16L14.6665 24"
          stroke="#111111"
          strokeWidth="5"
          strokeLinecap="square"
        />
        <path
          d="M6.6665 16L14.6665 8"
          stroke="#111111"
          strokeWidth="5"
          strokeLinecap="square"
        />
      </svg>
    );
  },
  Delete: function () {
    return (
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 5H17"
          stroke="#888888"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 9V15"
          stroke="#888888"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 9V15"
          stroke="#888888"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 5L3 17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H13C13.5304 19 14.0391 18.7893 14.4142 18.4142C14.7893 18.0391 15 17.5304 15 17L16 5"
          stroke="#888888"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 5V2C6 1.73478 6.10536 1.48043 6.29289 1.29289C6.48043 1.10536 6.73478 1 7 1H11C11.2652 1 11.5196 1.10536 11.7071 1.29289C11.8946 1.48043 12 1.73478 12 2V5"
          stroke="#888888"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  ArrowsSort: function () {
    return (
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 6L6 2M6 2L10 6M6 2V16"
          stroke="#ffffff"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M20 12L16 16M16 16L12 12M16 16V2"
          stroke="#ffffff"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </svg>
    );
  },
  Reload: function () {
    return (
      <svg height="25" width="25" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-47.37 -47.37 568.42 568.42" fill="#ffffff" stroke="#ffffff" transform="rotate(-45)">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#ffffff" strokeWidth="5.684124"/>
          <g id="SVGRepo_iconCarrier"> <path fill='#fd7e14' d="M473.677,236.84c0-130.814-106.036-236.838-236.835-236.838C106.036,0.002,0,106.03,0,236.84 c0,130.795,106.036,236.835,236.842,236.835C367.641,473.671,473.677,367.636,473.677,236.84z"/> <path fill='#FFFFFF' d="M370.457,138.893c-33.97-48.633-89.75-76.478-149.366-69.65C163.73,75.81,117.43,112.9,94.45,164.42 c-9.839-0.026-19.674-0.049-29.513-0.075c-5.187-0.011-9.016,5.991-6.099,10.564c17.243,27.052,34.49,54.108,51.733,81.16 c2.909,4.57,9.218,4.458,12.12-0.045c17.378-26.966,34.759-53.936,52.141-80.902c1.877-2.913,1.245-5.729-0.512-7.674 c-1.096-1.657-2.913-2.838-5.512-2.846c-9.151-0.022-18.301-0.045-27.452-0.067c42.216-67.088,144.695-73.21,192.801-4.338 C349.572,182.254,386.029,161.189,370.457,138.893z"/> <path fill='#F7F7F7' d="M213.601,238.089c0-12.146,9.839-21.985,21.977-21.985c12.139,0,21.977,9.839,21.977,21.985 c0,12.131-9.839,21.97-21.977,21.97C223.44,260.059,213.601,250.217,213.601,238.089z"/> <path fill='#FFFFFF' d="M414.449,297.545c-17.243-27.052-34.494-54.108-51.741-81.16c-2.909-4.57-9.218-4.458-12.12,0.045 c-17.374,26.966-34.756,53.936-52.133,80.902c-1.881,2.917-1.245,5.733,0.52,7.681c1.092,1.653,2.909,2.831,5.505,2.838 c9.151,0.022,18.301,0.045,27.448,0.067c-42.22,67.08-144.695,73.228-192.797,4.342c-15.407-22.06-51.86-0.995-36.293,21.304 c33.963,48.633,89.746,76.474,149.359,69.65c57.361-6.57,103.657-43.663,126.644-95.18c9.835,0.026,19.674,0.049,29.513,0.075 C413.537,308.124,417.366,302.118,414.449,297.545z"/> </g>
      </svg>
    )
  },
  Add: function () {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.999878V14.9999"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M1 8H15"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  checkSort: function () {
    return (
      <svg
        width="13"
        height="10"
        id="checkdropdown"
        viewBox="0 0 13 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.75 5L4.5 8.75L12 1.25"
          stroke="#4A4A4A"
          strokeLinecap="square"
        />
      </svg>
    );
  },
  sortLatest: function () {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 4.5H9.75"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 9H8.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 13.5H8.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 11.25L13.5 13.5L15.75 11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 4.5V13.5"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  sortOldest: function () {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 4.5H8.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 9H8.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 13.5H9.75"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 6.75L13.5 4.5L15.75 6.75"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 4.5V13.5"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  sort_az: function () {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 7.5V3.75C11.25 2.715 11.715 2.25 12.75 2.25C13.785 2.25 14.25 2.715 14.25 3.75V7.5M14.25 5.25H11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 15.75H11.25L14.25 10.5H11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 11.25L5.25 13.5L7.5 11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 4.5V13.5"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  sort_za: function () {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 15.75V12C11.25 10.965 11.715 10.5 12.75 10.5C13.785 10.5 14.25 10.965 14.25 12V15.75M14.25 13.5H11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 7.5H11.25L14.25 2.25H11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 11.25L5.25 13.5L7.5 11.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 4.5V13.5"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  sortUnfinished: function () {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.25 6.75L5.25 3.75M5.25 3.75L8.25 6.75M5.25 3.75V14.25"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 11.25L12.75 14.25M12.75 14.25L9.75 11.25M12.75 14.25V3.75"
          stroke="#16ABF8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  high: function () {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="7" fill="#F8A541" />
      </svg>
    );
  },
  veryHigh: function () {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="7" fill="#ED4C5C" />
      </svg>
    );
  },
  low: function () {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="7" fill="#428BC1" />
      </svg>
    );
  },
  veryLow: function () {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="7" fill="#8942C1" />
      </svg>
    );
  },
  medium: function () {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="7" fill="#00A790" />
      </svg>
    );
  },
  tablerChevronDown: function () {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 9L12 15L18 9" stroke="#111111" strokeLinecap="square" />
      </svg>
    );
  },
  nextIcon: function () {
    return (
      <svg
        width="6"
        height="10"
        viewBox="0 0 6 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.35841 4.40825L1.82507 0.874917C1.74761 0.79681 1.65544 0.734814 1.55389 0.692507C1.45234 0.6502 1.34342 0.628418 1.23341 0.628418C1.1234 0.628418 1.01448 0.6502 0.912927 0.692507C0.811378 0.734814 0.71921 0.79681 0.641741 0.874917C0.486532 1.03105 0.399414 1.24226 0.399414 1.46242C0.399414 1.68257 0.486532 1.89378 0.641741 2.04992L3.59174 4.99992L0.641741 7.94992C0.486532 8.10605 0.399414 8.31726 0.399414 8.53742C0.399414 8.75757 0.486532 8.96878 0.641741 9.12492C0.719608 9.20215 0.811955 9.26326 0.913486 9.30473C1.01502 9.3462 1.12374 9.36722 1.23341 9.36658C1.34308 9.36722 1.4518 9.3462 1.55333 9.30473C1.65486 9.26326 1.74721 9.20215 1.82507 9.12492L5.35841 5.59158C5.43652 5.51411 5.49851 5.42195 5.54082 5.3204C5.58312 5.21885 5.60491 5.10993 5.60491 4.99992C5.60491 4.88991 5.58312 4.78099 5.54082 4.67944C5.49851 4.57789 5.43652 4.48572 5.35841 4.40825Z"
          fill="#052c65"
        />
      </svg>
    );
  },
};

export default Icons;
